
import { Link } from "react-router-dom";
import { Card, CardContent } from "@/components/ui/card";
import { cn } from "@/lib/utils";

interface DashboardTileProps {
  title: string;
  description: string;
  icon: React.ReactNode;
  to: string;
  isPrimary?: boolean;
  count?: number;
  tourId?: string;
}

const DashboardTile = ({
  title,
  description,
  icon,
  to,
  isPrimary = false,
  count,
  tourId
}: DashboardTileProps) => {
  return (
    <Link to={to} className="block h-full">
      <Card 
        data-tour={tourId}
        className={cn(
          "h-full transition-transform hover-scale",
          isPrimary ? "bg-godyspo-gold text-black border-godyspo-gold" : "bg-card"
        )}
      >
        <CardContent className="flex flex-col h-full p-4 md:p-6">
          <div className="flex justify-between items-start mb-4">
            <h3 className={cn(
              "text-lg font-semibold",
              isPrimary ? "text-black" : "text-white"
            )}>
              {title}
              {count !== undefined && (
                <span className="ml-2 inline-flex items-center justify-center w-6 h-6 text-xs rounded-full bg-black/10">
                  {count}
                </span>
              )}
            </h3>
            <div className={cn(
              "text-2xl",
              isPrimary ? "text-black" : "text-godyspo-gold"
            )}>
              {icon}
            </div>
          </div>
          <p className={cn(
            "text-sm",
            isPrimary ? "text-black/80" : "text-muted-foreground"
          )}>
            {description}
          </p>
        </CardContent>
      </Card>
    </Link>
  );
};

export default DashboardTile;
